import React from 'react'

const divStyle = {
    background: `white`,
    padding: 5
}

const InfoWindowBody = (data, corralon) => {
    const {
        nombre: title,
        localidad: town,
        telefono: phone,
    } = data

    return !corralon ? (
        <div style={divStyle}>
            <h3>{data?.country + ' ' + data?.province}</h3>
            <div>Localidad: {data?.province + ', ' + data?.country}</div>
            <div>Teléfono: <a href={`tel:${data?.phone}`} target="_blank" rel="noreferrer" title={`Marcar al ${data?.phone}`}>{data?.phone}</a></div>
        </div>
    ) :
    (
        <div style={divStyle}>
        <h3>{data?.nombre}</h3>
        <div>Dirección: {data?.direccion + ', ' + data?.localidad}</div>
        <div>Email: {data?.email}</div>
        <div>Teléfono: <a href={`tel:${data?.telefono}`} target="_blank" rel="noreferrer" title={`Marcar al ${data?.telefono}`}>{data?.telefono}</a></div>
    </div>
    )
}

export default InfoWindowBody